export default __webpack_public_path__ + "static/media/image-chair-child-w@3x.57b02e56.png";